module.exports = __webpack_public_path__ + "src/assets/img/gsm-icon__disabled.9838c704.svg";